<template>
	<div>
		<div class="sections">
			<section>
				<h3>Incognito-Mode</h3>
				<RadioGroup
					v-model="type"
					:options="typeOptions"
					@change="typeChanged"
				/>
			</section>
			<section v-if="itemsEligible">
				<h3>Ausgeschlossene Personen</h3>
				<Item
					v-for="(item, i) in items"
					:key="item.id"
					:item="item"
					:is-last="i === (items.length - 1)"
					:is-lone="items.length === 1"
					:class="{'mt-2': i > 0}"
					@remove="removeItem(item)"
					@change="itemChanged(item, $event)"
					@add="addItem"
				/>
			</section>
		</div>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group.vue"
import RadioGroup from "@/vue/common/form/RadioGroup.vue";
import {getOptions, TYPE__ACTIVE} from "@/helper/job-profile/IncognitoMode";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";
import Item from "./incognito-mode/Item";
import {uuid} from "vue-uuid";

export default {
	components: {Item, RadioGroup, FormGroup},

	props: {
		value: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			type: this.value?.type,
			items: this.value?.items || [],
		};
	},

	computed: {
		typeOptions ()
		{
			return getOptions();
		},
		itemsEligible ()
		{
			return this.type === TYPE__ACTIVE;
		},
		itemsValid ()
		{
			if (!this.itemsEligible)
			{
				return true;
			}

			const validItems = this.items.filter(item => item.valid);

			return arrayIsNotEmpty(this.items) && this.items.length === validItems.length;
		},
		valid ()
		{
			return isDefined(this.type)
				&& this.itemsValid;
		}
	},

	methods: {
		typeChanged (type)
		{
			if (type === TYPE__ACTIVE && this.items.length === 0)
			{
				this.addItem();
			}

			this.emitChangeEvent();
		},
		removeItem (itemToRemove)
		{
			this.items = this.items.filter(item => item.id !== itemToRemove.id);

			this.emitChangeEvent();
		},
		itemChanged (item, data)
		{
			this.$set(item, 'firstName', data.firstName);
			this.$set(item, 'lastName', data.lastName);
			this.$set(item, 'yearOfBirth', data.yearOfBirth);
			this.$set(item, 'valid', data.valid);

			this.emitChangeEvent();
		},
		addItem ()
		{
			this.items.push({
				id: uuid.v4(),
				valid: false,
			});

			this.emitChangeEvent();
		},
		emitChangeEvent ()
		{
			if (!this.valid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				type: this.type,
				items: this.itemsEligible
					? this.items
					: undefined
			});
		}
	}
}
</script>
